import axios from 'axios';
import { put, takeLatest, takeEvery } from 'redux-saga/effects';

function* fetchStatistics(action) {
    try {
        const response = yield axios.get('/api/requests/statistics');
        yield put({ type: 'SET_STATISTICS', payload: response.data });
    } catch (error) {
        console.log('Error fetching requests', error);
    }
}

function* statisticsSaga() {
    yield takeLatest('FETCH_STATISTICS', fetchStatistics);
   

}

export default statisticsSaga;